import { Box, Stack, Typography } from "@mui/material";
import { EmployerFundLedger } from "../../../../models/funding/employerFundLedger";
import { formatCurrency } from "../../../../utils/formatters";
import { SideDrawer } from "../../../shared/SideDrawer";

const MonthlyUserFeeInfoSideDrawer = ({
  ledger,
  isOpen,
  setIsOpen
}: {
  ledger: EmployerFundLedger | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <SideDrawer
      title="Monthly Module User Fee Info"
      open={isOpen}
      setIsOpen={setIsOpen}
    >
      <Stack spacing={3} mx={2}>
        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Period
          </Typography>
          <Typography variant="body1">
            {ledger?.monthlyUserFeeMetadata?.month &&
            ledger?.monthlyUserFeeMetadata?.year
              ? `${new Date(
                  0,
                  ledger.monthlyUserFeeMetadata.month - 1
                ).toLocaleString("en-NZ", { month: "long" })} ${
                  ledger.monthlyUserFeeMetadata.year
                }`
              : "N/A"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            User Quantity
          </Typography>
          <Typography variant="body1">
            {ledger?.monthlyUserFeeMetadata?.quantity}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Fee
          </Typography>
          <Typography variant="body1">
            {ledger?.monthlyUserFeeMetadata?.fee
              ? formatCurrency(ledger?.monthlyUserFeeMetadata?.fee)
              : "N/A"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Module Type
          </Typography>
          <Typography variant="body1">
            {ledger?.monthlyUserFeeMetadata?.employerModuleType}
          </Typography>
        </Box>
      </Stack>
    </SideDrawer>
  );
};

export { MonthlyUserFeeInfoSideDrawer };
